// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"334":"6eb72043","528":"7027bb14","554":"4c13e05b","797":"ea967145"}[chunkId] + ".chunk.css";
};